const TICKET_KEYS = new Set(["shopify_install_context", "install_context"]);
const REDACTED = "[REDACTED]";

function redactText(text: string): string {
  // HTTP error integrations can serialize a POST body into a string.
  if (/^\s*[\[{]/.test(text)) {
    try {
      const parsed = JSON.parse(text);
      const sanitized = redactShopifyInstallTelemetry(parsed);
      if (JSON.stringify(parsed) !== JSON.stringify(sanitized))
        return JSON.stringify(sanitized);
    } catch {
      /* ordinary diagnostic message */
    }
  }
  let result = text;
  // Auth redirects encode a URL, and can encode another auth redirect inside it.
  // Match the exact query keys at each encoding depth, preserving other fields.
  for (let depth = 0; depth <= 5; depth++) {
    const encodedPrefix = depth === 0 ? "" : `%${"25".repeat(depth - 1)}`;
    const boundary = depth === 0 ? "[?&]" : `${encodedPrefix}(?:3[Ff]|26)`;
    const equals = depth === 0 ? "=" : `${encodedPrefix}3[Dd]`;
    const terminator =
      depth === 0
        ? "[&#\\s\"'<>]"
        : `(?:${encodedPrefix}(?:26|23|22|27)|[&#\\s"'<>])`;
    const pattern = new RegExp(
      `(${boundary}(?:shopify_install_context|install_context)${equals})(?:(?!${terminator}).)*`,
      "g",
    );
    let replacement = REDACTED;
    for (let level = 0; level < depth; level++)
      replacement = encodeURIComponent(replacement);
    result = result.replace(pattern, (_match, key) => key + replacement);
  }
  return result;
}

/** Only the two signed-install keys are removed; ordinary diagnostics survive. */
export function redactShopifyInstallTelemetry<T>(value: T): T {
  const seen = new WeakMap<object, unknown>();
  const visit = (item: unknown): unknown => {
    if (typeof item === "string") return redactText(item);
    if (!item || typeof item !== "object") return item;
    if (seen.has(item)) return seen.get(item);
    if (Array.isArray(item)) {
      const next: unknown[] = [];
      seen.set(item, next);
      item.forEach((entry) => next.push(visit(entry)));
      return next;
    }
    const next: Record<string, unknown> = {};
    seen.set(item, next);
    Object.entries(item).forEach(([key, entry]) => {
      next[key] = TICKET_KEYS.has(key) ? REDACTED : visit(entry);
    });
    return next;
  };
  return visit(value) as T;
}
